import { Directive, forwardRef, Attribute, ElementRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, Validators } from '@angular/forms';

@Directive({
    selector: '[appRequiredTrue]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredTrueValidator), multi: true }
    ]
})
export class RequiredTrueValidator implements Validator {

    constructor() { }

    validate(control: AbstractControl): { [key: string]: any } {
        return Validators.requiredTrue(control);
    }
}
